module.exports = __webpack_public_path__ + "static/media/36_A.08934da8.png";